
import React, { useState } from 'react';
import { Container, Card, Button, Alert, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../App.css';

const AdminClearScores: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleClearScores = async () => {
    setShowConfirm(false);
    setIsLoading(true);
    setError(null);
    setSuccess(null);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/scores`, {
        method: 'DELETE',
      });
      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.message || 'Failed to clear scores');
      }
      setSuccess('All fantasy scores have been successfully cleared.');
    } catch (err: any) {
      setError(err.message || 'Error clearing scores.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container className="mt-5 mb-5">
      <div className="mb-3">
        <Link to="/admin/dashboard" className="text-decoration-none">
          &larr; Back to Admin Home
        </Link>
      </div>
      <Card className="shadow-sm home-card border-danger">
        <Card.Header as="h4" className="card-title-custom text-center bg-danger text-white">DANGER ZONE - Clear All Scores</Card.Header>
        <Card.Body className="text-center">
          {error && <Alert variant="danger">{error}</Alert>}
          {success && <Alert variant="success">{success}</Alert>}
          
          <Alert variant="warning">
            <strong>This action is irreversible!</strong> Clicking the button below will delete all entered scores for all episodes and all castaways.
          </Alert>

          <Button
            variant="danger"
            size="lg"
            onClick={() => setShowConfirm(true)}
            disabled={isLoading}
          >
            {isLoading ? 'Clearing...' : 'Clear ALL Fantasy Scores'}
          </Button>

          <div className="mt-4">
            <Link to="/admin/dashboard" className="btn btn-secondary">Back to Admin Dashboard</Link>
          </div>
        </Card.Body>
      </Card>

      <Modal show={showConfirm} onHide={() => setShowConfirm(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Score Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you absolutely sure you want to delete all scores? This cannot be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirm(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleClearScores}>
            Yes, Delete All Scores
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default AdminClearScores;
